import React from "react";
import "../styles/Modal.css";

export default function LoginPromptModal({ open, onClose, onLogin }) {
  if (!open) return null;

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="modal-card login" dir="rtl" onClick={(e) => e.stopPropagation()} style={{width:"600px", height:"150px"}}>
        <header className="modal-header">
          <h3 className="modal-title">تنبيه</h3>
          <button type="button" className="modal-close" onClick={onClose} aria-label="إغلاق">
            ×
          </button>
        </header>

        <div className="modal-body">
          <p style={{ margin: 0, paddingRight:"20px" }}>سجّل دخول عشان تشوف سياراتك المحفوظة</p>
        </div>

        <footer className="modal-footer">
          <button className="btn outline" onClick={onClose}>إلغاء</button>
          <button className="btn solid" onClick={onLogin}>تسجيل الدخول</button>
        </footer>
      </div>
    </div>
  );
}
